import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import map from "../assets/kangaroo/Home_Offices.jpg";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import Button from "../component/button/Button";
import selectbtn from "../assets/kangaroo/selectbtn.svg";
import Dropdown from "../component/dropdown/Dropdown";
import dropdownarrow from "../assets/kangaroo/dropdown-arrow.png";
import "../Homepage/Component/Homepage.css";
import Smallbutton from "../component/button/Smallbutton";
import { useNavigate } from "react-router-dom";
import ContactService from "../services/ContactService";
import { useQuery } from "@tanstack/react-query";

const Map = () => {
  const router = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);

  const fetchData = async () => {
    const response = await ContactService.getList();
    return response;
  };

  const {
    isPending,
    error,
    data: countryData,
  } = useQuery({
    queryKey: ["mapData"],
    queryFn: fetchData,
  });

  const dropdownItems = countryData?.items?.map((item) => ({
    id: item.id,
    label: item.city,
  }));

  const handleSelectClick = () => {
    if (selectedItem) {
      router('/contact', { state: { selectedOffice: selectedItem } });
    }
  };

  return (
    <div className="main-container">
      <Container fluid className="p-0">
        <Row className="m-0" style={{ height: "600px" }}>
          <Col className="p-0">
            <div
              className="d-flex flex-column justify-content-center align-items-center rounded-5 p-0 py-4"
              style={{
                backgroundImage: `url(${map})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                minHeight: "600px",
                width: "100%",
              }}
            >
              <h1 className="lh-1 font-level-5 fw-normal text-center px-3">
                FIND A KANGAROO EDUCATION <br className="d-none d-sm-block" />
                FOUNDATION'S OFFICE NEAR YOU
              </h1>

              {/* Single Row containing both dropdown and button */}
              <Row className="mt-4 g-0" style={{ width: "clamp(200px, 45vw, 500px)" }}>
                <Col xs={12} className="mb-4">
                  <Dropdown
                    items={dropdownItems}
                    placeholder="Select Office"
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    arrowIcon={dropdownarrow}
                  />
                </Col>

                
              </Row>
              
                  <div 
                    onClick={handleSelectClick}
                    style={{ cursor: selectedItem ? "pointer" : "not-allowed" }}
                  >
                    <Smallbutton
                      width="270px"
                      height="clamp(55px, 15vw, 60px)"
                      fontSize={23}
                      className={"mx-auto"}
                    />
                  </div>
                
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Map;